import React from 'react';
import { Target, Eye, CheckCircle } from 'lucide-react';
import { aboutContent } from '../data/mock';

const About = () => {
  const highlights = [
    "Certified SAP consultants",
    "Expert staffing solutions",
    "Modern app development",
    "Digital transformation focus"
  ];

  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            <span className="text-teal-600 font-semibold text-sm uppercase tracking-wider">About Us</span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-800 mt-3 mb-6">
              {aboutContent.title.replace('About ', '')}
            </h2>
            <p className="text-slate-500 text-lg mb-4">
              {aboutContent.subtitle}
            </p>
            
            {aboutContent.paragraphs.map((para, index) => (
              <p key={index} className="text-slate-600 leading-relaxed mb-4">
                {para}
              </p>
            ))}

            {/* Highlights */}
            <div className="grid grid-cols-2 gap-3 mt-8">
              {highlights.map((item, index) => (
                <div key={index} className="flex items-center gap-2">
                  <CheckCircle className="w-5 h-5 text-teal-500 flex-shrink-0" />
                  <span className="text-slate-700 font-medium text-sm">{item}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right - Mission & Vision Cards */}
          <div className="space-y-6">
            {/* Mission Card */}
            <div className="relative bg-gradient-to-br from-slate-50 to-teal-50/50 rounded-2xl p-8 border border-slate-100">
              <div className="absolute top-0 right-0 w-32 h-32 bg-teal-500/5 rounded-full -translate-y-1/2 translate-x-1/2"></div>
              <div className="relative z-10">
                <div className="w-12 h-12 bg-teal-500 rounded-xl flex items-center justify-center mb-4">
                  <Target className="w-6 h-6 text-white" />
                </div>
                <h3 className="text-xl font-bold text-slate-800 mb-3">Our Mission</h3>
                <p className="text-slate-600 leading-relaxed">
                  {aboutContent.mission}
                </p>
              </div>
            </div>

            {/* Vision Card */}
            <div className="relative bg-gradient-to-br from-slate-50 to-cyan-50/50 rounded-2xl p-8 border border-slate-100">
              <div className="absolute bottom-0 left-0 w-32 h-32 bg-cyan-500/5 rounded-full translate-y-1/2 -translate-x-1/2"></div>
              <div className="relative z-10">
                <div className="w-12 h-12 bg-cyan-500 rounded-xl flex items-center justify-center mb-4">
                  <Eye className="w-6 h-6 text-white" />
                </div>
                <h3 className="text-xl font-bold text-slate-800 mb-3">Our Vision</h3>
                <p className="text-slate-600 leading-relaxed">
                  {aboutContent.vision}
                </p>
              </div>
            </div>

            {/* Location Badge */}
            <div className="flex items-center gap-3 bg-slate-100 rounded-xl p-4">
              <div className="w-10 h-10 bg-slate-200 rounded-lg flex items-center justify-center">
                <svg className="w-5 h-5 text-slate-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              </div>
              <div>
                <p className="text-slate-500 text-sm">Headquartered in</p>
                <p className="text-slate-800 font-semibold">Goa, India</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
